import { VAT_RATE } from '../data/trainingBillingOptions'
import { getTrainingProduct, formatCourseDate } from './trainingCourses'
import { teacherFullName } from './teachers'
import { Practice } from '../types/practice'
import { Teacher } from '../types/teacher'
import { TrainingCourse } from '../types/trainingCourse'
import { BadgeVariant } from '../components/ui/Badge'
import { TrainingBillingStatus } from '../types/trainingBilling'

export interface CourseAssociation {
  course?: TrainingCourse
  productCode: string
  productLabel: string
  courseCode?: string
  isOnDemand: boolean
  // Data di svolgimento, empty for on-demand courses
  dateLabel?: string
  teachers: string[]
}

// Course data taken from the "Corsi" database through the practice's course code
export function courseAssociation(
  practice: Practice,
  courses: TrainingCourse[],
  teachers: Teacher[],
): CourseAssociation {
  const course = practice.courseCode
    ? courses.find((c) => c.courseCode === practice.courseCode)
    : undefined
  const productCode = course?.productCode || practice.productCode
  const product = getTrainingProduct(productCode)
  const isOnDemand =
    course?.status === 'ondemand' || practice.deliveryMode === 'elearning'
  const start = course?.startDate || practice.courseStartDate
  const end = course?.endDate || practice.courseEndDate
  const dateLabel = isOnDemand || !start
    ? undefined
    : end && end !== start
      ? `${formatCourseDate(start)} – ${formatCourseDate(end)}`
      : formatCourseDate(start)
  return {
    course,
    productCode,
    productLabel: product ? `${product.type} — ${product.name}` : productCode || '-',
    courseCode: course?.courseCode || practice.courseCode,
    isOnDemand,
    dateLabel,
    teachers: (course?.teachers || []).map((ct) =>
      teacherFullName(teachers.find((t) => t.id === ct.teacherId)),
    ),
  }
}

export function withVat(amount?: number): number | undefined {
  return amount === undefined ? undefined : Math.round(amount * (1 + VAT_RATE) * 100) / 100
}

export function billingStatusVariant(status: TrainingBillingStatus): BadgeVariant {
  switch (status) {
    case 'Proforma da fare':
    case 'Fattura da fare':
      return 'warning'
    case 'Proforma effettuata':
    case 'Fattura effettuata':
      return 'info'
    case 'Pagamento in revisione':
      return 'primary'
    case 'Fattura pagata':
      return 'success'
    default:
      return 'danger'
  }
}
